export default __webpack_public_path__ + "static/media/07_na_pastwisku.b4395fd5.png";